export default {
  postureReport: "Relatório de Postura",
  postureData: "Dados de Postura",
  postureLogData: "Dados de Registro de Postura",
  postureDataContrast: "Contraste de Dados de Postura",
  postureRiskContrast: "Contraste de Risco de Postura",
  postureDataTrend: "Tendência de Dados de Postura",
  postureRiskTrend: "Tendência de Risco de Postura",
  lateralhead: "Inclinação lateral da cabeça",
  unevenshoulder: "Ombros desalinhados",
  scoliosis: "Escoliose",
  unevenhip: "Inclinação lateral da pélvis",
  xleg: "Joelho valgo",
  oleg: "joelho varo",
  roundedshoulder: "Protusão de ombros",
  kneehyperextension: "Hiperextensao dos joelhos",
  trunkforwardtilt: "Inclinação do tronco para frente",
  trunklateraltilt: "Inclinação lateral do tronco",
  ankleheelleft: "Calcanhar esquerdo",
  ankleheelright: "Calcanhar direito",
  forwardhead: "Protusão de cabeça ",
  toTheLeft: "(esquerda)",
  toTheRight: "(direita)",
  bracketsLeft: "(E)",
  bracketsRight: "(D)",
  bracketsNormal: "(Normal)",
  leg: "Perna",
  legLeft: "Perna (E)",
  legRight: "Perna (D)",
  riskAssessment: "Avaliação de risco",
  muscleState: "Estado do músculo",
  muscleStateDesc: "Nenhuma condição muscular anormal encontrada",
  testTime: "Tempo de Teste",
  hRisk: "H",
  mRisk: "M",
  lRisk: "L",
  item: "Itens",
  degree: "°",
  percent: "%",
  mm: "mm",
  moireImage: "Imagem moiré",
  lAbnormalRisk: "Baixo risco",
  mAbnormalRisk: "Médio risco",
  hAbnormalRisk: "Alto risco",
  highRisk: "Alto Risco",
  riskAnalysis: "Análise de Risco",
  conclusionRecommendation: "Conclusão e Recomendação",
  solution: "Solução",
  movePosition: "Clique no ponto para mover a posição",
  confirmTheClose: "Ainda não foi salvo! Confirma o fechamento?",
  closeInfo: "Ainda não foi salvo! Confirma o fechamento?",
  share: "Compartilhar",
  front: "Anterior",
  side: "Perfil",
  back: "Posterior",
  otherSide: "Outro Lado",
  points: "Pontos",
  angle: "ângulo",
  name: "Nome",
  gender: "Gênero",
  male: "masculino",
  female: "feminino",
  age: "Idade",
  year: "anos",
  height: "Altura",
  weight: "Peso",
  time: "Tempo",
  patientId: "ID do Paciente",
  save: "Salvar",
  saveModify: "Salvar Modificar",
  print: "Imprimir",
  cancel: "Cancelar",
  zoomIn: "Zoom In",
  zoomOut: "Zoom Out",
  ok: "OK",
  return: "Voltar",
  empty: "",
  unknown: "desconhecido",
  succeedToCopy: "Copiado com sucesso",
  succeedToSave: "Salvo com sucesso",
  headForwardDistance: "Distância da cabeça para frente",
  pelvisForwardTilt: "Inclinação pélvica para frente",
  wristHipDistanceLeft: "Distância punho quadril (Esquerda)",
  wristHipDistanceRight: "Distância punho quadril (direita)",
  evaluator: "Avaliador",
  reportDate: "Data do relatório",
  introduction: "Introdução",
  doctorIntroDefault: "Área profissional: Medicina de reabilitação, avaliação e correção postural | Anos de experiência: mais de 5 anos | Especialidade: Reabilitação de lesões esportivas, correção postural, gerenciamento da dor",
  recoveryLog: "Registro de Recuperação",
  returnToReport: "Voltar ao Relatório",
  loading: "Carregando...",
  showToolbox: "Mostrar caixa de ferramentas",
  hideToolbox: "Ocultar caixa de ferramentas",
};

